import React, { useEffect } from "react";
import PropTypes from "prop-types";

import ModalPortal from "../sections/common/ModalPortal";

/**
 * Small error dialog surfaced by useCallFlow when the call flow can't
 * proceed — no appointment selected, no patient phone on file, or the
 * /initiate-call endpoint returned an error. Copy is caller-supplied
 * so one shell serves every failure mode.
 */
const CallErrorDialog = ({ title, message, onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <ModalPortal>
      <div
        className="cc-modal-backdrop"
        role="presentation"
        onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}
      >
        <div
          className="cc-modal cc-call-error"
          role="dialog"
          aria-modal="true"
          aria-labelledby="cc-call-error-title"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <header className="cc-modal-head">
            <span id="cc-call-error-title" className="cc-modal-title">
              {title || "Call failed"}
            </span>
          </header>
          <div className="cc-modal-body">
            <p>{message || "Something went wrong. Please try again."}</p>
          </div>
          <footer className="cc-modal-foot">
            <button
              type="button"
              className="cc-modal-btn cc-modal-btn-primary"
              onClick={onClose}
            >
              OK
            </button>
          </footer>
        </div>
      </div>
    </ModalPortal>
  );
};

CallErrorDialog.propTypes = {
  title:   PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

CallErrorDialog.defaultProps = {
  title:   "",
  message: "",
};

export default CallErrorDialog;
